import { render, staticRenderFns } from "./machineryServiceDetail.vue?vue&type=template&id=37b62a54&scoped=true"
import script from "./machineryServiceDetail.vue?vue&type=script&lang=js"
export * from "./machineryServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./machineryServiceDetail.vue?vue&type=style&index=0&id=37b62a54&prod&lang=less&scoped=true"
import style1 from "./machineryServiceDetail.vue?vue&type=style&index=1&id=37b62a54&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b62a54",
  null
  
)

export default component.exports